<div ngbTooltip="{{'order.newOrder' | translate}}" placement="left" container="body"
    triggers="hover" tooltipClass="apc-tooltip-left" class="add-float-icon" (click)="open(content)">
    <div class="icon" aria-label="plus" [inlineSVG]="'assets/ico/plus-regular.svg'"></div>
</div>
<ng-template #content let-modal>
        <div class="modal-header light-blue">
            <div class="container-fluid">
                <div class="row modal-header-row">
                    <div class="modal-icon icon fill-white" aria-label="logo"
                        [inlineSVG]="'assets/ico/orders.svg'">
                    </div>
                    <span class="modal-title" id="modal-basic-title">{{'order.newOrder' | translate}}</span>
                    <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                        [inlineSVG]="'assets/ico/close-24px.svg'"></div>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="fullwidth">
                <div class="container-fluid">
                      <nejo-order-data [isCreate]="true" [editForm]="true" [createOrder]="createOrderEvent" (createOrderSuccess)="close()"></nejo-order-data> 
                </div>
            </div>
        </div>
        <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
                <span class="btn modal-btn save" (click)="createOrder()">Create New Order</span>
            </div>
        </div>
</ng-template>